import React from 'react';

import { Box, Button, CardActions, ButtonGroup, CircularProgress } from '@mui/material';

import { IDocumentVersion, IPdfFileMeta } from 'utils/DexieDBManager';
import useOnlineStatus from 'utils/InternetChecker/useOnlineStatus';
import FontAwesomeSvgIcon from 'Layouts/Common/FontAwesomeSvgIcon';
import PdfDocumentCardDetails from './PdfDocumentCardDetails';
import svgFonts from 'Layouts/Common/fontAwesome';
import { isPwa} from 'utils/pwa';

import {
  styledPdfCardActions,
  styledPdfCardActionsBtn,
  styledPdfCardActionsBtnIcon,
  styledPdfCardActionsBtnGroup,
} from './stylesPdfDocumentCards';


interface IPdfDocumentCardActionsProps {
  isTogglingPdfDocumentFavoriteState: boolean;
  documentPdfFileMeta?: IPdfFileMeta;
  isDownloadPdfFileLoading: boolean;
  documentVersion: IDocumentVersion;
  isStarredDocument: boolean;
  handleDownloadPdfDocument: () => void;
  handleTogglePdfDocumentFavoriteState: () => void;
}

const PdfDocumentCardActions: React.FunctionComponent<IPdfDocumentCardActionsProps> = ({
  isTogglingPdfDocumentFavoriteState,
  isDownloadPdfFileLoading,
  documentPdfFileMeta,
  isStarredDocument,
  documentVersion,
  handleDownloadPdfDocument,
  handleTogglePdfDocumentFavoriteState,
}) => {
  const [isPdfDocumentCardDetailsOpen, setIsPdfDocumentCardDetailsOpen] = React.useState(false);
  const handleOpenPdfCardDetails = () => setIsPdfDocumentCardDetailsOpen(true);
  const { isOnline } = useOnlineStatus();

  const isFavoriteButtonDisabled = isTogglingPdfDocumentFavoriteState || !isOnline;

  return (
    <>
      <CardActions sx={styledPdfCardActions}>
        <ButtonGroup
          variant='contained'
          fullWidth={true}
          size='large'
          aria-label='outlined primary button group'
          sx={styledPdfCardActionsBtnGroup}>
          <Button sx={styledPdfCardActionsBtn} onClick={handleOpenPdfCardDetails}>
            <Box component='span' sx={styledPdfCardActionsBtnIcon}>
              <FontAwesomeSvgIcon icon={svgFonts.faCircleInfo} sx={styledPdfCardActionsBtnIcon} />
            </Box>
          </Button>
          <Button
            sx={styledPdfCardActionsBtn}
            disabled={isFavoriteButtonDisabled}
            onClick={handleTogglePdfDocumentFavoriteState}>
            <Box component='span' sx={styledPdfCardActionsBtnIcon}>
              <FontAwesomeSvgIcon
                icon={isStarredDocument ? svgFonts.faStar : svgFonts.faStarAlternative}
                sx={styledPdfCardActionsBtnIcon}
              />
            </Box>
          </Button>
          {isPwa && !documentPdfFileMeta?.isBufferSavedInDB && (
            <Button
              disabled={isDownloadPdfFileLoading}
              sx={styledPdfCardActionsBtn}
              onClick={handleDownloadPdfDocument}>
              <Box component='span' sx={styledPdfCardActionsBtnIcon}>
                {isDownloadPdfFileLoading ? (
                  <CircularProgress color='warning' size={20} />
                ) : (
                  <FontAwesomeSvgIcon icon={svgFonts.faCloudArrowDown} sx={styledPdfCardActionsBtnIcon} />
                )}
              </Box>
            </Button>
          )}
        </ButtonGroup>
      </CardActions>
      <PdfDocumentCardDetails
        setIsPdfDocumentCardDetailsOpen={setIsPdfDocumentCardDetailsOpen}
        isPdfDocumentCardDetailsOpen={isPdfDocumentCardDetailsOpen}
        documentVersion={documentVersion}
      />
    </>
  );
};

export default PdfDocumentCardActions;
